<template>
    <svg viewBox="0 0 115 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 7.79004H6.84174L10.8256 18.0168L14.8612 7.79004H21.5227L11.4919 32.0001H4.78813L7.53391 25.5848L0 7.79004Z"
            fill="#5F01D1"
        />
        <path
            d="M28.4605 7.38281C23.32 7.38281 20.0703 12.0086 20.0703 16.6152C20.0703 21.799 23.6332 25.9088 28.363 25.9088C31.8913 25.9088 33.2216 23.7519 33.2216 23.7519V25.432H39.1889V7.79004H33.2216V9.39386C33.2216 9.39386 31.7374 7.38281 28.4605 7.38281ZM29.7298 13.0523C32.1017 13.0523 33.3257 14.9354 33.3257 16.6346C33.3257 18.4643 32.0144 20.2599 29.7298 20.2599C27.8364 20.2599 26.1253 18.7073 26.1253 16.7125C26.1253 14.6894 27.5016 13.0523 29.7298 13.0523Z"
            fill="#5F01D1"
        />
        <path
            d="M41.2461 25.432V0H47.4875V9.45499C47.4875 9.45499 48.97 7.38504 52.0749 7.38504C55.8728 7.38504 58.098 10.2244 58.098 14.2816V25.432H51.9022V15.8091C51.9022 14.436 51.2504 13.1096 49.7739 13.1096C48.2708 13.1096 47.4875 14.4561 47.4875 15.8091V25.432H41.2461Z"
            fill="#5F01D1"
        />
        <path
            d="M68.7399 7.38477C62.853 7.38477 59.3477 11.8763 59.3477 16.6885C59.3477 22.1648 63.5918 25.9086 68.7622 25.9086C73.7735 25.9086 78.1585 22.3347 78.1585 16.7803C78.1585 10.7028 73.5672 7.38477 68.7399 7.38477ZM68.7961 13.104C70.8755 13.104 72.3143 14.8418 72.3143 16.695C72.3143 18.2756 70.9736 20.2252 68.7961 20.2252C66.8008 20.2252 65.3034 18.6192 65.3034 16.6777C65.3034 14.8074 66.5483 13.104 68.7961 13.104Z"
            fill="#5F01D1"
        />
        <path
            d="M88.5563 7.38477C82.6694 7.38477 79.1641 11.8763 79.1641 16.6885C79.1641 22.1648 83.4082 25.9086 88.5786 25.9086C93.5899 25.9086 97.9749 22.3347 97.9749 16.7803C97.9749 10.7028 93.3836 7.38477 88.5563 7.38477ZM88.6125 13.104C90.6919 13.104 92.1307 14.8418 92.1307 16.695C92.1307 18.2756 90.79 20.2252 88.6125 20.2252C86.6172 20.2252 85.1198 18.6192 85.1198 16.6777C85.1198 14.8074 86.3647 13.104 88.6125 13.104Z"
            fill="#5F01D1"
        />
        <path
            d="M102.898 25.8064C105.187 25.8064 107.043 23.9445 107.043 21.6478C107.043 19.3511 105.187 17.4893 102.898 17.4893C100.609 17.4893 98.7539 19.3511 98.7539 21.6478C98.7539 23.9445 100.609 25.8064 102.898 25.8064Z"
            fill="#5F01D1"
        />
        <path
            d="M108.407 15.9618H100.945L107.567 0H115.001L108.407 15.9618Z"
            fill="#5F01D1"
        />
    </svg>
</template>
